// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading[data-v-3f6ce67c]{display:flex;align-items:center;justify-content:center;flex-wrap:nowrap;flex-direction:column;gap:.13333rem}.loading .van-loading__text[data-v-3f6ce67c]{font-size:.37333rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
